export function SettingsDrawerLeadsSection(props: {
  emptyLeadAutoDeleteEnabled: boolean;
  setEmptyLeadAutoDeleteEnabled: (v: boolean) => void;
  syncedCount: number;
  viableCount: number;
  isSyncing: boolean;
  onSyncAllLeads: () => Promise<void>;
}) {
  const {
    emptyLeadAutoDeleteEnabled,
    setEmptyLeadAutoDeleteEnabled,
    syncedCount,
    viableCount,
    isSyncing,
    onSyncAllLeads,
  } = props;

  return (
    <section className="space-y-4">
      <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400">Leads</h3>

      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-medium">Auto-delete empty leads</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Removes blank placeholders when closed. Recommended ON.
          </div>
        </div>
        <button
          type="button"
          onClick={() => setEmptyLeadAutoDeleteEnabled(!emptyLeadAutoDeleteEnabled)}
          className={
            "relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors " +
            (emptyLeadAutoDeleteEnabled ? "bg-indigo-600" : "bg-gray-300 dark:bg-gray-600")
          }
          role="switch"
          aria-checked={emptyLeadAutoDeleteEnabled}
        >
          <span
            className={
              "inline-block h-4 w-4 rounded-full bg-white shadow transform transition-transform " +
              (emptyLeadAutoDeleteEnabled ? "translate-x-6" : "translate-x-1")
            }
          />
        </button>
      </div>

      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-medium">Supabase sync</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            {syncedCount} of {viableCount} lead{viableCount !== 1 ? "s" : ""} synced
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <span
            className={
              "inline-block h-2 w-2 rounded-full " +
              (syncedCount >= viableCount && viableCount > 0
                ? "bg-emerald-500"
                : viableCount === 0
                  ? "bg-gray-300 dark:bg-gray-600"
                  : "bg-amber-400")
            }
          />
          <button
            type="button"
            disabled={isSyncing || syncedCount >= viableCount}
            onClick={() => onSyncAllLeads().catch(console.warn)}
            className={
              "text-xs px-3 py-1.5 rounded-full border " +
              (isSyncing || syncedCount >= viableCount
                ? "border-gray-200 dark:border-gray-700 text-gray-400 cursor-not-allowed"
                : "border-indigo-300 dark:border-indigo-700 bg-indigo-50 dark:bg-indigo-950 text-indigo-900 dark:text-indigo-200 hover:bg-indigo-100 dark:hover:bg-indigo-900")
            }
          >
            {isSyncing ? "Syncing…" : syncedCount >= viableCount ? "In sync" : "Sync all"}
          </button>
        </div>
      </div>
    </section>
  );
}
